export const SYMBOL_COLOR_PLACEHOLDER = '{{color}}';

export function tintSvg(svg: string, color: string): string {
  return svg.replaceAll(SYMBOL_COLOR_PLACEHOLDER, color);
}

export function svgContainsColorPlaceholder(svg: string): boolean {
  return svg.includes(SYMBOL_COLOR_PLACEHOLDER);
}
